import { Button } from 'antd';
import React from 'react';

const SaveCancelButton = ({ handleCloseModal }) => {
  return (
    <div className="center">
      <Button className="w-40" onClick={handleCloseModal}>
        Cancel
      </Button>
      <Button
        className="customButton ml-4 w-40"
        htmlType="submit"
        // onClick={onFinish}
      >
        Save Changes
      </Button>
    </div>
  );
};

export default SaveCancelButton;
